var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"login"}},[_c('Header'),_c('h1',{staticClass:"heading"},[_vm._v("Please Login.")]),_c('div',{attrs:{"id":"firebaseui-auth-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }